import { createSlice } from '@reduxjs/toolkit';

const createTicketModal = createSlice({
  name: 'createTicketModal',
  initialState: {
    open: false,
    data: null,
  },
  reducers: {
    show: (state, { payload }) => {
      state.open = true;
      state.data = payload;
    },
    close: (state) => {
      state.open = false;
      state.data = null;
    },
  },
});

export const createTicketModalActions = createTicketModal.actions;
export const createTicketModalReducer = createTicketModal.reducer;
export default createTicketModalReducer;

export const selectCreateTicketModalStatus = (state) => state.createTicketModal.open;
export const selectCreateTicketModalData = (state) => state.createTicketModal.data;
